export namespace ScheduleActions {

  export class UpdateEventPrice {
    static readonly type = '[SchedulesState] UpdateEventPrice';
    constructor(public price: number) { }
  }

  export class UpdateCalendarFilter {
    static readonly type = '[SchedulesState] UpdateCalendarFilter';
    constructor(public state: string | null) { }
  }

  export class UpdateSearchFilter {
    static readonly type = '[SchedulesState] UpdateSearchFilter';
    constructor(public state: string) { }
  }

}
